module.exports = __webpack_public_path__ + "static/user-segmentation-57d03f9a7599d1ec860fefb2defd8cee.png";